<template>
  <section :class="{ 'section-builder-cta': true }">
    <GeneralTheme :theme="configuration">
      <CtaBannerComponent
        v-if="ctaData"
        :data="ctaData"
      />
    </GeneralTheme>
  </section>
</template>

<script lang="ts" setup>
import type { SectionBuilderCTABanner } from '~/sanity/types';
import CtaBannerComponent from './CTABanner.vue';
import { useRefsStore } from '~/composables/refsStore';
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
const props = defineProps<SectionBuilderCTABanner>();
const { getResolvedCTABanner } = useRefsStore();
const ctaData = await getResolvedCTABanner(props.CTABanner?.reference?._ref);
</script>
